import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "fade-slider",
  class FadeSlider extends WYATTElement {
    constructor() {
      super();
      this.activeClass = "fade-slider__slide--active";
      this.baseSlideClass = "fade-slider__slide";
      this.speed = parseInt(this.dataset?.speed || 5000, 10);
      this.slides = this.querySelectorAll(`.${this.baseSlideClass}`);
      this.interval = null;
    }

    setTransitions() {
      this.slides.forEach((slide) => {
        slide.style.transitionProperty = "opacity";
        slide.style.transitionDuration = `300ms`;
        slide.style.transitionTimingFunction = "ease-in-out";
      });
    }

    setActiveSlide(slide) {
      slide.classList.add(this.activeClass);
      slide.style.opacity = 1;
      this.activeSlide = slide;
    }

    setInactiveSlide(slide) {
      slide.classList.remove(this.activeClass);
      slide.style.opacity = 0;
    }

    goToNext() {
      const slideCount = this.slides.length;
      let nextIndex = 0;
      if (this.activeIndex < slideCount - 1) {
        nextIndex = this.activeIndex + 1;
      }
      const nextSlide = this.slides[nextIndex];
      this.setInactiveSlide(this.activeSlide);
      this.setActiveSlide(nextSlide);
      this.activeIndex = nextIndex;
    }

    animate() {
      this.interval = setInterval(() => {
        this.goToNext();
      }, this.speed);
    }

    initialize() {
      this.activeIndex = 0;
      this.setActiveSlide([...this.slides].at(this.activeIndex));
      this.setTransitions();

      this.animate();
    }

    connectedCallback() {
      if (this.slides.length > 1) {
        this.initialize();
      }
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  },
);
